import { render, staticRenderFns } from "./PrivacyPolicyClient.vue?vue&type=template&id=84ba3f9a&scoped=true"
import script from "./PrivacyPolicyClient.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyClient.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPolicyClient.vue?vue&type=style&index=0&id=84ba3f9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ba3f9a",
  null
  
)

export default component.exports